module.exports = __webpack_public_path__ + "img/ic_transfer.160c2ab2.svg";